export const NOTFOUND = "/notfound";
export const COMMUNITY_PAGE_CODE = "/page/:service_code/";
export const COMMUNITY_PAGE_CODE_CATEGORY = ":title";
// export const COMMUNITY_PAGE_CODE_LANG = "/page/:service_code/:title/:lang";
export const COMMUNITY_PAGE_CODE_IDX = ":idx";
export const COMMUNITY_MYPAGE = "/profile/:profilekey";
